<mat-form-field appearance="outline" class="search-by">
	<mat-select [(ngModel)]="selectedSearchBy">
		@for (option of searchByOptions; track option?.value) {
			<mat-option class="opt" [value]="option.value" (click)="selectionChange(option.value)">
			 {{'general.search_by' | translate}} {{ option.label | translate}}
			</mat-option>
		}
	</mat-select>
  </mat-form-field>
  